'use strict'

import axios from 'axios'
import { useErrorsStore } from '@/store/errors'

export const ApiDeleev = axios.create({
  baseURL: import.meta.env.VITE_DELEEV_API_BASE_URL,
})

ApiDeleev.interceptors.response.use(
  (response) => response,
  (error) => {
    // Interception des erreurs réseau
    if (error.message === 'Network Error') {
      const errorsStore = useErrorsStore()
      errorsStore.encouterNetworkError()
    }
    return Promise.reject(error)
  },
)
export const ApiDeleevConfig = {
  setAuthorizationToken(token) {
    if (!token) return
    ApiDeleev.defaults.headers.common.Authorization = `Token ${token}`
  },
  removeAuthorizationToken() {
    delete ApiDeleev.defaults.headers.common.Authorization
  },
}

export const ApiUtils = {
  promiseGet(httpClient, path, options) {
    return new Promise((resolve, reject) => {
      ;(httpClient || axios)
        .get(path, options)
        .then((response) => {
          if (response.status >= 400) reject(response)
          else resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  promiseGetWithStatus(httpClient, path, options) {
    return new Promise((resolve, reject) => {
      ;(httpClient || axios)
        .get(path, options)
        .then((response) => {
          if (response.status >= 400) {
            reject(response)
          } else {
            resolve({
              datas: response.data,
              status: response.status,
            })
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  promisePost(httpClient, path, data, options) {
    return new Promise((resolve, reject) => {
      httpClient
        .post(path, data, options || {})
        .then((response) => {
          if (response.status >= 400) reject(response)
          else resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  promisePut(httpClient, path, data, options) {
    return new Promise((resolve, reject) => {
      httpClient
        .put(path, data, options || {})
        .then((response) => {
          if (response.status >= 400) reject(response)
          else resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // Use this when you do a partial update of the object
  promisePatch(httpClient, path, data, options) {
    return new Promise((resolve, reject) => {
      httpClient
        .patch(path, data, options || {})
        .then((response) => {
          if (response.status >= 400) reject(response)
          else resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  promiseDelete(httpCLient, path, options) {
    return new Promise((resolve, reject) => {
      httpCLient
        .delete(path, options || {})
        .then((response) => {
          if (response.status >= 400) reject(response)
          else resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
